import React, { Component } from 'react';
import { Link } from "react-router-dom";
import _ from "lodash";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import track from "../lib/tracking";

class EbookPopup extends Component {

  state = {
    visible: false,
    ready:false
  }

  componentDidMount() {
    setTimeout(() => {
      !this.props.authed && this.setState({visible:true});
      setTimeout(() => this.setState({ready:true}),800);
    },8000)
  }

  render() {

    if(!this.state.visible){
      return <div/>;
    }


    return (
      <div className={this.state.ready ? "ebook-popup ebook-popup--ready": "ebook-popup" }>
        <div className="poster" >
          <img src="/ebook_thumb.png"/>
        </div>
        <div className="info" >
          <div onClick={() => {track("close_ebook_popup",{});this.setState({visible:false});}} className="close-button"><FontAwesomeIcon icon="times" /></div>
          <h3>Get our ebook!</h3>
          <div className="description">Get a step by step guide to preparing and launching online campaigns.</div>
          <div className="button"><a href="https://www.gruvi.tv/ebook" target="_blank">DOWNLOAD EBOOK</a></div>
        </div>
      </div>
    );
  }

}

export default EbookPopup;



// WEBPACK FOOTER //
// ./src/components/EbookPopup.js